import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const BangladeshSection = () => {
  const navigate = useNavigate();
  const [activeCity, setActiveCity] = useState(null);
  const { t, language } = useLanguage();

  const bdFeatures = [
    {
      id: 1,
      icon: 'Building2',
      title: language === 'bn' ? 'ঢাকা মেট্রো — ঢাকা মেট্রো ইন্টেলিজেন্স' : 'ঢাকা মেট্রো — Dhaka Metro Intelligence',
      description: language === 'bn' ?'গুলশান, বনানী, ধানমন্ডি, উত্তরা, বসুন্ধরা ও মিরপুরের এআই-চালিত বিশ্লেষণ। মধ্যম অ্যাপার্টমেন্ট মূল্য ৳৮৫ লাখ–৳২.৫ কোটি (২০২৫)। ঢাকা সিটি কর্পোরেশনের ৪০+ থানা কভার করে।' :'AI-powered analysis of Gulshan, Banani, Dhanmondi, Uttara, Bashundhara & Mirpur. Median apartment price ৳85L–৳2.5Cr (2025). Covers all 40+ Dhaka city corporation thanas.',
      searchQuery: 'Dhaka',
      areas: ['Gulshan', 'Banani', 'Dhanmondi', 'Uttara']
    },
    {
      id: 2,
      icon: 'Anchor',
      title: language === 'bn' ? 'চট্টগ্রাম — বন্দর নগরী' : 'চট্টগ্রাম — Chittagong Port City',
      description: language === 'bn' ?'বাংলাদেশের বাণিজ্যিক রাজধানীতে রিয়েল এস্টেটের বিকাশ। আগ্রাবাদ, নাসিরাবাদ, হালিশহর ও পাঁচলাইশ। বন্দর অর্থনীতি দ্বারা চালিত শক্তিশালী বাণিজ্যিক ও আবাসাসিক চাহিদা।' :'Bangladesh\'s commercial capital with booming real estate. Agrabad, Nasirabad, Halishahar & Panchlaish. Strong commercial and residential demand driven by port economy.',
      searchQuery: 'Chittagong',
      areas: ['Agrabad', 'Nasirabad', 'Halishahar', 'Panchlaish']
    },
    {
      id: 3,
      icon: 'Leaf',
      title: language === 'bn' ? 'সিলেট — প্রবাসী বাংলাদেশিদের হাব' : 'সিলেট — Sylhet NRB Hub',
      description: language === 'bn' ?'অনাবাসী বাংলাদেশিদের (NRB) শীর্ষ গন্তব্য। জিন্দাবাজার, আম্বরখানা, শাহজালাল উপশহর। যুক্তরাজ্য/যুক্তরাষ্ট্র প্রবাসীদের বিনিয়োগ ও প্রিমিয়াম ভিলা উন্নয়ন।' :'Top destination for Non-Resident Bangladeshis (NRB). Zindabazar, Amberkhana, Shahjalal Upashahar. Strong UK/US diaspora investment with premium villa developments.',
      searchQuery: 'Sylhet',
      areas: ['Zindabazar', 'Amberkhana', 'Shahjalal Upashahar', 'Subhanighat']
    },
    {
      id: 4,
      icon: 'Waves',
      title: language === 'bn' ? 'কক্সবাজার — পর্যটন রিয়েল এস্টেট' : "কক্সবাজার — Cox\'s Bazar Tourism",
      description: language === 'bn' ?'বিশ্বের দীর্ঘতম প্রাকৃতিক সমুদ্র সৈকত। রিসোর্ট ও আতিথেয়তা রিয়েল এস্টেটের বিকাশ। কলাতলী, সুগন্ধা, মেরিন ড্রাইভ করিডোর। স্বল্পমেয়াদী ভাড়া বিনিয়োগে উচ্চ ROI।' : "World's longest natural sea beach. Booming resort and hospitality real estate. Kolatoli, Sugandha, Marine Drive corridor. High ROI for short-term rental investments.",
      searchQuery: "Cox\'s Bazar",
      areas: ['Kolatoli', 'Sugandha', 'Marine Drive', 'Inani']
    },
    {
      id: 5,
      icon: 'Factory',
      title: language === 'bn' ? 'গাজীপুর ও নারায়ণগঞ্জ — শিল্প অঞ্চল' : 'গাজীপুর ও নারায়ণগঞ্জ — Industrial Zones',
      description: language === 'bn' ?'গাজীপুর ও নারায়ণগঞ্জ শিল্প করিডোর। ঢাকার কাছে সাশ্রয়ী আবাসিক বিকল্প। গার্মেন্ট শ্রমিক ও কারখানা ব্যবস্থাপনার কাছ থেকে শক্তিশালী ভাড়ার চাহিদা।' :'Gazipur and Narayanganj industrial corridors. Affordable residential options near Dhaka. Strong rental demand from garment sector workers and factory management.',
      searchQuery: 'Gazipur',
      areas: ['Tongi', 'Joydebpur', 'Fatullah', 'Siddhirganj']
    },
    {
      id: 6,
      icon: 'Globe',
      title: language === 'bn' ? 'রাজউক অনুমোদিত প্রকল্প' : 'রাজউক অনুমোদিত — RAJUK Approved Projects',
      description: language === 'bn' ?'সমস্ত তালিকা রাজউক (রাজধানী উন্নয়ন কর্তৃপক্ষ) অনুমোদনের বিপরীতে যাচাই করা হয়েছে। পূর্বাচল নিউ টাউন, উত্তরা ৩য় পর্যায়, ঝিলমিল আবাসিক এলাকা — সরকার-সমর্থিত উন্নয়ন।' :'All listings verified against RAJUK (Rajdhani Unnayan Kartripakkha) approvals. Purbachal New Town, Uttara 3rd Phase, Jhilmil Residential Area — government-backed developments.',
      searchQuery: 'Purbachal',
      areas: ['Purbachal', 'Uttara 3rd Phase', 'Jhilmil', 'Bashundhara R/A']
    }
  ];

  const bdStats = [
    { value: '৳85L+', label: language === 'bn' ? 'ঢাকার মধ্যম মূল্য' : 'Dhaka Median Price' },
    { value: '8', label: language === 'bn' ? 'প্রধান শহর কভার' : 'Major Cities Covered' },
    { value: 'RAJUK', label: language === 'bn' ? 'নিয়ন্ত্রক সম্মতি' : 'Regulatory Compliance' },
    { value: '100%', label: language === 'bn' ? 'বাংলাদেশ কভারেজ' : 'BD Coverage' }
  ];

  const bdCities = [
    { name: 'Dhaka', bn: 'ঢাকা', icon: '🏙️', query: 'Dhaka' },
    { name: 'Chittagong', bn: 'চট্টগ্রাম', icon: '⚓', query: 'Chittagong' },
    { name: 'Sylhet', bn: 'সিলেট', icon: '🍃', query: 'Sylhet' },
    { name: "Cox\'s Bazar", bn: 'কক্সবাজার', icon: '🌊', query: "Cox\'s Bazar" },
  ];

  const handleSearch = (query) => {
    navigate(`/search-results?q=${encodeURIComponent(query)}&region=bangladesh`);
  };

  return (
    <section id="bangladesh" className="py-12 md:py-20 lg:py-28 relative overflow-hidden" style={{ background: 'transparent' }}>
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full" style={{
          background: 'radial-gradient(circle, rgba(0, 180, 80, 0.07) 0%, transparent 70%)',
          filter: 'blur(60px)'
        }} />
        <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full" style={{
          background: 'radial-gradient(circle, rgba(220, 20, 60, 0.06) 0%, transparent 70%)',
          filter: 'blur(60px)'
        }} />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4" style={{
            background: 'rgba(0, 180, 80, 0.1)',
            border: '1px solid rgba(0, 180, 80, 0.3)'
          }}>
            <span className="text-lg">🇧🇩</span>
            <span className="text-xs font-semibold tracking-wider uppercase" style={{ color: '#00B450' }}>
              {language === 'bn' ? 'বাংলাদেশ বাজার' : 'Bangladesh Market'}
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4" style={{ color: '#FFFFFF' }}>
            {t('bangladeshTitle')}
          </h2>
          <p className="text-sm md:text-base max-w-2xl mx-auto" style={{ color: '#6B9EC4' }}>
            {t('bangladeshSubtitle')}
          </p>
        </div>

        {/* City Quick Select */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {bdCities?.map((city) => (
            <button
              key={city?.name}
              onClick={() => { setActiveCity(city?.name); handleSearch(city?.query); }}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200"
              style={{
                background: activeCity === city?.name ? 'rgba(0, 180, 80, 0.15)' : 'rgba(255,255,255,0.04)',
                border: activeCity === city?.name ? '1px solid rgba(0, 180, 80, 0.5)' : '1px solid rgba(255,255,255,0.1)',
                color: activeCity === city?.name ? '#00B450' : '#6B9EC4',
              }}
            >
              <span>{city?.icon}</span>
              <span>{language === 'bn' ? city?.bn : city?.name}</span>
              {language !== 'bn' && <span className="text-xs opacity-70">{city?.bn}</span>}
            </button>
          ))}
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {bdStats?.map((stat, i) => (
            <div key={i} className="text-center p-4 rounded-xl" style={{
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(0, 180, 80, 0.15)'
            }}>
              <div className="text-xl md:text-2xl font-bold mb-1" style={{ color: '#00B450' }}>{stat?.value}</div>
              <div className="text-xs" style={{ color: '#6B9EC4' }}>{stat?.label}</div>
            </div>
          ))}
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {bdFeatures?.map((feature) => (
            <div
              key={feature?.id}
              className="p-5 rounded-2xl transition-all duration-300 cursor-pointer group"
              style={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(0, 180, 80, 0.15)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.border = '1px solid rgba(0, 180, 80, 0.4)';
                e.currentTarget.style.background = 'rgba(0, 180, 80, 0.06)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.border = '1px solid rgba(0, 180, 80, 0.15)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
              }}
              onClick={() => handleSearch(feature?.searchQuery)}
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="p-2 rounded-lg flex-shrink-0" style={{ background: 'rgba(0, 180, 80, 0.12)' }}>
                  <Icon name={feature?.icon} size={18} color="#00B450" />
                </div>
                <h3 className="text-sm font-semibold leading-snug" style={{ color: '#FFFFFF' }}>{feature?.title}</h3>
              </div>
              <p className="text-xs leading-relaxed mb-3" style={{ color: '#6B9EC4' }}>{feature?.description}</p>
              {/* Popular areas */}
              <div className="flex flex-wrap gap-1.5">
                {feature?.areas?.map((area) => (
                  <span key={area} className="px-2 py-0.5 rounded-md text-xs" style={{
                    background: 'rgba(0, 180, 80, 0.08)',
                    border: '1px solid rgba(0, 180, 80, 0.2)',
                    color: '#00B450'
                  }}>{area}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* RAJUK Compliance Banner */}
        <div className="rounded-2xl p-5 md:p-6 mb-8" style={{
          background: 'rgba(0, 180, 80, 0.06)',
          border: '1px solid rgba(0, 180, 80, 0.25)'
        }}>
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-center gap-3 flex-shrink-0">
              <div className="p-2.5 rounded-xl" style={{ background: 'rgba(0, 180, 80, 0.15)' }}>
                <Icon name="ShieldCheck" size={22} color="#00B450" />
              </div>
              <div>
                <div className="text-sm font-bold" style={{ color: '#FFFFFF' }}>
                  {language === 'bn' ? 'রাজউক সম্মতি বিশ্লেষণ' : 'RAJUK Compliance Intelligence'}
                </div>
                <div className="text-xs" style={{ color: '#6B9EC4' }}>রাজধানী উন্নয়ন কর্তৃপক্ষ</div>
              </div>
            </div>
            <div className="flex-1 text-xs leading-relaxed" style={{ color: '#6B9EC4' }}>
              {language === 'bn' ?'সমস্ত বাংলাদেশ তালিকা রাজউক (রাজধানী উন্নয়ন কর্তৃপক্ষ) অনুমোদিত পরিকল্পনার সাথে ক্রস-রেফারেন্স করা হয়েছে। ক্রয়ের আগে ডেভেলপার নিবন্ধন, বিল্ডিং পারমিট এবং ভূমি ব্যবহার ছাড়পত্র যাচাই করুন।' :'All Bangladesh listings are cross-referenced with RAJUK (Rajdhani Unnayan Kartripakkha) approved plans. Verify developer registration, building permits, and land use clearance before purchase.'
              }
            </div>
            <button
              onClick={() => window.open('http://www.rajuk.gov.bd', '_blank')}
              className="px-4 py-2 rounded-lg text-xs font-semibold transition-all duration-200 flex-shrink-0"
              style={{
                background: 'rgba(0, 180, 80, 0.15)',
                border: '1px solid rgba(0, 180, 80, 0.4)',
                color: '#00B450'
              }}
            >
              {language === 'bn' ? 'রাজউক পোর্টাল দেখুন →' : 'Visit RAJUK Portal →'}
            </button>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <div className="flex flex-wrap justify-center gap-3 mb-4">
            <button
              onClick={() => handleSearch('Dhaka')}
              className="px-8 py-3 rounded-xl text-sm font-bold transition-all duration-200"
              style={{
                background: 'linear-gradient(135deg, #00B450, #007A35)',
                color: '#FFFFFF',
                boxShadow: '0 0 20px rgba(0, 180, 80, 0.35)'
              }}
            >
              🇧🇩 {language === 'bn' ? 'বাংলাদেশের সম্পত্তি দেখুন' : 'Explore Bangladesh Properties'}
            </button>
            <button
              onClick={() => navigate('/bangladesh-market-intelligence-reports')}
              className="px-6 py-3 rounded-xl text-sm font-bold transition-all duration-200 flex items-center gap-2"
              style={{
                background: 'rgba(0, 180, 80, 0.1)',
                border: '1px solid rgba(0, 180, 80, 0.4)',
                color: '#00B450',
              }}
            >
              <Icon name="BarChart2" size={15} />
              {language === 'bn' ? 'বাজার বিশ্লেষণ রিপোর্ট' : 'Market Intelligence Reports'}
            </button>
            <button
              onClick={() => navigate('/rajuk-compliance-intelligence')}
              className="px-6 py-3 rounded-xl text-sm font-bold transition-all duration-200 flex items-center gap-2"
              style={{
                background: 'rgba(0, 180, 80, 0.1)',
                border: '1px solid rgba(0, 180, 80, 0.4)',
                color: '#00B450',
              }}
            >
              <Icon name="ShieldCheck" size={15} />
              {language === 'bn' ? 'রাজউক সম্মতি যাচাই' : 'RAJUK Compliance'}
            </button>
          </div>
          <p className="text-xs mt-3" style={{ color: '#6B9EC4' }}>
            {language === 'bn' ?'বাংলাদেশি টাকায় (৳) মূল্য • রাজউক যাচাইকৃত তালিকা' :'Prices in BDT (Bangladeshi Taka ৳) • RAJUK verified listings'
            }
          </p>
        </div>
      </div>
    </section>
  );
};

export default BangladeshSection;
